import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import Analyse from "../screens/Analyse";
import { connect } from "react-redux";
import Home from "../screens/Home";
import VideoTabWithMs from "../screens/VideoTabWithMs";
import MatchUpdate from "../screens/MatchUpdate";
import { ManagementScreen } from "../screens/management";
import MatchDetails from "../screens/MatchDetails";
import LiveTaggingBoard from "../screens/LiveTaggingBoard";
import VideoTabOld from "../screens/VideoTabOld";
import TechQC from "../screens/TechQC";
import TechQCMS from "../screens/TechQCMS";
import ReviewPortal from "../screens/ReviewPortal";
import VersionHistory from "../screens/VersionHistory";
import ManagementVersionHistory from "../screens/management/ManagementVersionHistory";
import {
  DeviceManagementPage,
  RegistrationRequestsPage,
  AdminCredentialsPage,
  WEBAUTHN_ENABLED,
} from "../features/webauthn";
import { DuplicatePlayerApprovalsPage, SameCountryFlagsReportPage } from "../features/duplicatePlayer";

const MainRouter = (props) => {
  let location = useLocation();
  let background = location.state && location.state.background;
  return (
    <Switch location={background || location}>
      <Route exact path="/">
        <Redirect to="/home" />
      </Route>
      <Route path="/home">
        <Home />
      </Route>
      {/* More-specific management sub-routes MUST come before /management
          because React Router v5 Switch matches on prefix and /management
          without `exact` would swallow /management/history/:matchId */}
      <Route path="/management/history/:matchId">
        <ManagementVersionHistory />
      </Route>
      <Route path="/management">
        <ManagementScreen />
      </Route>
      <Route path="/analyse/:matchId">
        <Analyse />
      </Route>
      <Route path="/live-analyse/:matchId">
        <LiveTaggingBoard />
      </Route>
      <Route path="/matchupdate/:matchId">
        <MatchUpdate />
      </Route>
      <Route path="/videoplayer">
        <VideoTabWithMs />
      </Route>
      <Route path="/videoplayerold">
        <VideoTabOld />
      </Route>
      <Route path="/techQC/:matchId">
        <TechQC />
      </Route>
      <Route path="/techQCMS/:matchId">
        <TechQCMS />
      </Route>
      <Route path="/review/:matchId">
         <ReviewPortal />
      </Route>
      <Route path="/history/:matchId">
        <VersionHistory />
        </Route>
      <Route path="/match-details/:matchId">
        <MatchDetails />
      </Route>
      {WEBAUTHN_ENABLED && (
        <Route path="/settings/devices">
          <DeviceManagementPage />
        </Route>
      )}
      {WEBAUTHN_ENABLED && props.isSuperAdmin && (
        <Route path="/admin/webauthn/requests">
          <RegistrationRequestsPage />
        </Route>
      )}
      {WEBAUTHN_ENABLED && props.isSuperAdmin && (
        <Route path="/admin/webauthn/credentials">
          <AdminCredentialsPage />
        </Route>
      )}
      {/* Duplicate-flow spec §11 — Admin and Privileged analysts only. */}
      {(props.isAdmin || props.isSuperAdmin) && (
        <Route path="/admin/duplicate-players">
          <DuplicatePlayerApprovalsPage />
        </Route>
      )}
      {(props.isAdmin || props.isSuperAdmin) && (
        <Route path="/admin/duplicate-flags">
          <SameCountryFlagsReportPage />
        </Route>
      )}
    </Switch>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isAdmin: state.auth.isAdmin,
    isSuperAdmin: state.auth.isSuperAdmin,
  };
};

export default connect(mapStateToProps, {})(MainRouter);
